import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { KeycloakService } from 'keycloak-angular'
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = `${environment.restLoginUrl}/users`;
  private oAuthUrl =`${environment.OAuthApiUrl}/keycloak1/getValidation`;
  constructor(private http: HttpClient) { }
  public userName$ = new Subject<any>();
  private kc: KeycloakService

  check_userValid(req){
    return this.http.post(`${this.oAuthUrl}`,req)
  }

  ayurwaySignIn(request: any) {
    return this.http.post<any>(`${environment.restAPIUrl}/api/public/signin`, request)
  };
  ayurwaySignUp(request) {
    return this.http.post<any>(`${environment.restAPIUrl}/api/public/create`, request)
  }
  private getCountry_Id =new BehaviorSubject<any>(null);
  signIn(request: any) {
    return this.http.post<any>(`${this.apiUrl}/signin`, request)
  }

  signUp(request: any) {
    return this.http.post<any>(`${this.apiUrl}/create`, request)
  };

  setUpdateName(userName: any) {
    this.userName$.next(userName);
  };
  getUpdateName() {
    return this.userName$.asObservable();
  };
  clearToken() {
    this.userName$.next();
  };
  setCountryId(id){
    this.getCountry_Id.next(id)
  };
  getCountryId(){
    return this.getCountry_Id.asObservable();
  }
  createPasswordService(data){
    return this.http.post(`${environment.restAPIUrl}/api/public/activateUser`,data)
  };

  forgotPasswordService(data) {
    return this.http.post(`${environment.restAPIUrl}/api/public/forgotPassword`, data)
  };

  memberActivation(req) {
    return this.http.post(`${environment.restAPIUrl}/api/members/activateAccount`, req)
  }
}
